module.exports = __webpack_public_path__ + "static/img/juvenile.944805e8.svg";